<template>
  <div class="sy-pur-line-type-detail-wrap">
    <el-tooltip v-if="content" placement="top" popper-class="sy-pur-line-type-detail-read-text-tooltip-popper">
      <div slot="content">{{content}}</div>
      <div class="sy-pur-line-type-detail-con">{{content}}</div>
    </el-tooltip>
    <span v-else>-</span>
  </div>
</template>

<script>
import Api from "./api"
import response from "../../../../utils/response/index.js"
import { componentMessage } from "../../utils"

export default {
  name: "pur-line-type-detail",
  components: {
  },
  data() {
    return {
      purLineTypeInfo: {},
      content: '' // 采购行展示文字
    }
  },
  props: {
    code: [String]
  },
  watch: {
    code: {
      handler: function (nVal, oVal) {
        if (nVal) { 
          this.getPurLineTypeDetail()
        }
      },
      immediate: true
    }
  },
  async created() {
    // 适用于商城端和采购商端
    let flag = componentMessage(
      ["mall", "purchaser"],
      "pur-line-type 采购行类型"
    )
    if (flag) return
  },
  methods: {
    formatInfo ({name, receiveTypeName, purchaseTypeName}) {
      this.content = `${name}  ${receiveTypeName}/${purchaseTypeName}`
    },
    // 获取采购行类型详情
    async getPurLineTypeDetail() {
      const api = Api.getById
      const params = {
        code: this.code
      }
      const res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        this.purLineTypeInfo = res.content || {}
        this.formatInfo(this.purLineTypeInfo)
      }
    },
  },
}
</script>

<style scoped lang="scss">
.sy-pur-line-type-detail-wrap {
  display: inline-block;
  width: 100%;
  // overflow: hidden;
  // text-overflow: ellipsis;
  // white-space: nowrap;
}
.sy-pur-line-type-detail-con {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
<style>
.sy-pur-line-type-detail-read-text-tooltip-popper {
  max-width: 300px;
}
</style>
